/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum UserStatus {
    DE_ACTIVE = 'DeActive',
    ACTIVE = 'Active',
    SOFT_DELETED = 'SoftDeleted',
}
